import React from 'react';
import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { AboutReviewsLink } from 'src/components/review-summary/components/about-link';
import { ReviewsSummary } from 'src/components/review-summary';
import SotyPromo from '../shop-of-the-year-promo';

import {
  useSotyState,
  SotyState,
} from 'src/areas/landing-page/components/soty-banner/use-soty-state';

import { UserReviewSummary } from '../../../../types';
import { BelongsTo, Store, Review } from '../../../reviews/types';

type OwnProps = {
  className?: string;
  store: Store;
  userReviewsSummary: UserReviewSummary;
  myReview?: Review;
};

const SideColumn = ({
  className,
  store,
  userReviewsSummary,
  myReview,
}: OwnProps) => {
  const sotyState = useSotyState();

  const belongsTo = {
    id: store.id,
    name: store.name,
    type: 'store',
  } as BelongsTo;

  return (
    <div className={className}>
      <ReviewsSummary
        rating={userReviewsSummary.rating}
        count={userReviewsSummary.count}
        countTotal={userReviewsSummary.countTotal}
        distribution={userReviewsSummary.distribution}
        store={store}
        myReview={myReview}
        belongsTo={belongsTo}
        showPrompt
      />
      <AboutLink />

      {sotyState === SotyState.PROMO && (
        <SotyPromo belongsTo={belongsTo} myReview={myReview} store={store} />
      )}
    </div>
  );
};

export default SideColumn;

const AboutLink = styled(AboutReviewsLink)`
  margin-top: ${layout.measurements.spacing100};
`;
